import { validationMethods } from '../../../Utils/validationMethods';

const validation = {
  mileage: validationMethods.requiredNumberGreaterOrEqualThanZero,
  condition: validationMethods.requiredCondition,
};

export default validation;
